import { useState, useEffect, useRef } from "react";
import GridCatalogoSimulado from "./GridCatalogoSimulado";
import { getProdutosFiltradosPaginado } from "../../api/public";

const CelularMockup = ({
  username,
  termoDeBusca,
  tag,
  produtoIdSelecionado,
  setProdutoIdSelecionado,
  onFecharModal,
  tags
}) => {
  const [produtos, setProdutos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const sentinelaRef = useRef(null);

  const carregarProdutos = async (reset = false) => {
    if (carregando || page > totalPages) return;

    setCarregando(true);
    try {
      const resultado = await getProdutosFiltradosPaginado(username, {
        page: reset ? 1 : page,
        busca: termoDeBusca,
        tag: tag === "todas" ? "" : tag,
      });

      setProdutos(prev => reset ? resultado.produtos : [...prev, ...(resultado.produtos || [])]);
      setTotalPages(resultado.totalPages || 1);
      setPage(reset ? 2 : page + 1);
    } catch (error) {
      console.error("Erro ao carregar produtos:", error);
    } finally {
      setCarregando(false);
    }
  };

  // Carrega produtos quando os filtros mudam
  useEffect(() => {
    setProdutos([]);
    setPage(1);
    carregarProdutos(true);
  }, [username, termoDeBusca, tag]);

  // Implementa scroll infinito
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !carregando && page <= totalPages) {
          carregarProdutos();
        }
      },
      { root: null, rootMargin: "100px", threshold: 0.1 }
    );

    if (sentinelaRef.current) {
      observer.observe(sentinelaRef.current);
    }

    return () => observer.disconnect();
  }, [carregando, page, totalPages]);

  return (
    <div className="w-[280px] h-[580px] rounded-[36px] border-8 border-gray-800 overflow-hidden shadow-xl m-6 relative bg-white flex flex-col">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 mt-2 w-20 h-3.5 bg-gray-700 rounded-xl z-10"></div>
      <div className="flex-1 overflow-y-scroll pt-6 px-1 z-0">
        <GridCatalogoSimulado
          produtos={produtos}
          busca={termoDeBusca}
          categoria={tag}
          produtoIdSelecionado={produtoIdSelecionado}
          setProdutoIdSelecionado={setProdutoIdSelecionado}
          onFecharModal={onFecharModal}
          carregando={carregando}
          tags={tags}
        />
        <div ref={sentinelaRef} className="h-2"></div>
        {carregando && (
          <div className="text-center text-gray-400 text-sm my-4">Carregando mais produtos...</div>
        )}
      </div>
    </div>
  );
};

export default CelularMockup;